import React, { Fragment } from 'react';
export function TrustBar() {
  const items = [{
    icon: '🛡️',
    text: 'Compra Segura'
  }, {
    icon: '⚡',
    text: 'Entrega Instantánea'
  }, {
    icon: '❤️',
    text: '+4,500 Familias Felices'
  }];
  return <section className="bg-white py-3 border-y border-gray-100" data-id="element-167">
      <div className="max-w-4xl mx-auto px-4" data-id="element-168">
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-169">
          {items.map((item, index) => <Fragment key={index} data-id="element-170">
              <div className="flex items-center gap-2 text-sm md:text-base font-medium text-deep-blue/80" data-id="element-171">
                <span className="text-xl" data-id="element-172">{item.icon}</span>
                <span data-id="element-173">{item.text}</span>
              </div>
              {index < items.length - 1 && <div className="hidden md:block w-1 h-1 rounded-full bg-gray-300" data-id="element-174" />}
            </Fragment>)}
        </div>
      </div>
    </section>;
}